export default __webpack_public_path__ + "static/media/home-screen-two.b98eb33e.jpeg";